module.exports = __webpack_public_path__ + "static/media/movie.eb6ca60b.png";